module.exports = __webpack_public_path__ + "static/media/toggle-open.d0869919.svg";